import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getSmsReturnAvailability = unaryRpc({
  name: "getSmsReturnAvailability",
  input: z.object({}),
  output: z.object({ available: z.boolean() }),
});
